import React from 'react';
import styles from "../../Admin/Dashboard/dashboard.module.scss";
import Typography from "../../../../components/Typography";
import { get2DigitFormattedNumber } from "../../../../actions/commonActions";
import { useWelcomeBannerUserManagement } from '../../../../hooks/dashboard';
import pluralize from "pluralize";

const Status = () => {
    const { data: bannerDetails } = useWelcomeBannerUserManagement({ userType: 'customer' });
    const customerCount = bannerDetails && bannerDetails.customerCount ? bannerDetails.customerCount : 0;
    const companyCount = bannerDetails && bannerDetails.companyCount ? bannerDetails.companyCount : 0;
    const activeCount = bannerDetails && bannerDetails.activeUserCount ? bannerDetails.activeUserCount : 0;
    return (
        <div className={`${styles.overview} h-full`}>
            <div className={styles.background}></div>
            <div className={"flex"}>
                <div className={"flex-1"}>
                    <Typography variant={"h5"}>You have added <span
                        className={"text-secondary-900 font-bold"}>{get2DigitFormattedNumber(customerCount)} {pluralize('User', customerCount)}</span> for this customer, out of which <span
                            className={"text-secondary-900 font-bold"}>{get2DigitFormattedNumber(activeCount)} </span> are active </Typography>
                </div>
                <div>
                </div>
            </div>
        </div>
    );
};

export default Status;
